import { render } from "./ModelPairingTab.vue?vue&type=template&id=333051e5&scoped=true"
import script from "./ModelPairingTab.vue?vue&type=script&lang=js"
export * from "./ModelPairingTab.vue?vue&type=script&lang=js"

import "./ModelPairingTab.vue?vue&type=style&index=0&id=333051e5&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333051e5"]])

export default __exports__